import Component from './Component';

/**
 * @class SectionComponent
 * @classdesc Class representing a section component.
 * @extends Component
 */
export default class SectionComponent extends Component {
  /**
   * @constructor
   * @param {HTMLElement} el - The component element.
   * @param {Object} context - The component's context.
   */
  constructor(el, context = {}) {
    super(el, context);

    this._sectionWrapper = el.parentElement;
    // ID's of Shopify sections are preceded by 'shopify-section-' when using
    // the HTML wrapper ID as the source, so let's remove that
    this._sectionId = this._sectionWrapper.id.replace('shopify-section-', '');
  }

  /**
   * Get the section's Shopify wrapper
   *
   * @memberof SectionComponent.prototype
   * @type {HTMLElement} Section's Shopify wrapper element.
   */
  get sectionWrapper() {
    return this._sectionWrapper;
  }

  /**
   * Get the section's Shopify wrapper ID
   *
   * @memberof SectionComponent.prototype
   * @type {string} Section's Shopify wrapper ID.
   */
  get sectionId() {
    return this._sectionId;
  }

  /**
   * Called when the component is selected in the Shopify Theme Editor.
   *
   * @memberof SectionComponent.prototype
   */
  onSelect() {
    return undefined;
  }

  /**
   * Called when the component is deselected in the Shopify Theme Editor.
   *
   * @memberof SectionComponent.prototype
   */
  onDeselect() {
    return undefined;
  }

  /**
   * Called when the component is reordered in the Shopify Theme Editor.
   *
   * @memberof SectionComponent.prototype
   */
  onReorder() {
    return undefined;
  }

  /**
   * Called when a block within the section is selected in the Shopify Theme Editor.
   *
   * @memberof SectionComponent.prototype
   */
  onBlockSelect() {
    return undefined;
  }

  /**
   * Called when a block within the section is deselected in the Shopify Theme Editor.
   *
   * @memberof SectionComponent.prototype
   */
  onBlockDeselect() {
    return undefined;
  }
}
